import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPublicAPIKeysRPC } from "./getPublicApiKeysRPC";

export class GetPublicAPIKeysRPCClientImpl extends GetPublicAPIKeysRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPublicAPIKeysRPC.Request): Promise<LeoRPCResult<GetPublicAPIKeysRPC.Response, GetPublicAPIKeysRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "external-public-apis/GetPublicAPIKeys",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPublicAPIKeysRPC.ResponseDTO,
      GetPublicAPIKeysRPC.Errors.ErrorsDTO,
      GetPublicAPIKeysRPC.Response,
      GetPublicAPIKeysRPC.Errors.Errors
    >(
      response,
      "external-public-apis/GetPublicAPIKeys",
      GetPublicAPIKeysRPC.Response.fromDTO,
      GetPublicAPIKeysRPC.Errors.fromDTO
    );
  }
}
